import ImageEditPreview from './image-edit-preview';
import { ComponentImage } from '../component.constants';

const ImageEditPreviewDrawer = ({
  componentId,
  stimulusId,
  sectionId,
  contentId,
  componentImage,
}: {
  componentId: string;
  stimulusId: number;
  sectionId: string;
  contentId: number;
  componentImage: Omit<ComponentImage, '__typename'>;
}) => {
  return (
    <ImageEditPreview
      componentId={componentId}
      contentId={contentId}
      sectionId={sectionId}
      componentImage={componentImage}
    />
  );
};

export default ImageEditPreviewDrawer;
